// src/components/Button/Button.js
import React from 'react';
import './Button.css';

const Button = ({
  children,
  variant = 'primary', // primary, secondary, success, warning, danger, ghost, outline
  size = 'medium', // small, medium, large
  disabled = false,
  loading = false,
  fullWidth = false,
  icon = null,
  iconPosition = 'left', // left, right
  onClick,
  type = 'button',
  className = '',
  style = {},
  ...props
}) => {
  // Base button classes
  const baseClasses = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    disabled && 'btn-disabled',
    loading && 'btn-loading',
    fullWidth && 'btn-full-width',
    icon && 'btn-with-icon',
    !children && icon && 'btn-icon-only', // Add btn-icon-only when no children and icon is present
    className
  ].filter(Boolean).join(' ');

  // Handle click events
  const handleClick = (e) => {
    if (disabled || loading) return;
    if (onClick) onClick(e);
  };

  // Loading spinner component
  const LoadingSpinner = () => (
    <span className="btn-spinner">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="37.7"
          strokeDashoffset="37.7"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 8 8;360 8 8"
            dur="1s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-dashoffset"
            values="37.7;0;37.7"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </span>
  );

  return (
    <button
      className={baseClasses}
      onClick={handleClick}
      disabled={disabled || loading}
      type={type}
      style={style}
      {...props}
    >
      {loading && <LoadingSpinner />}
      
      {!loading && icon && iconPosition === 'left' && (
        <span className="btn-icon btn-icon-left">{icon}</span>
      )}
      
      <span className={`btn-content ${loading ? 'btn-content-loading' : ''}`}>
        {children}
      </span>
      
      {!loading && icon && iconPosition === 'right' && (
        <span className="btn-icon btn-icon-right">{icon}</span>
      )}
    </button>
  );
};

export default Button;